module.exports = __webpack_public_path__ + "_assets/img/information.f5f7d23e.svg";